import { cloneDeep, get } from 'lodash'

import { Services, empty, getServiceNameViaPoint, getShortUrl, regExp } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsDomainsStates } from '@sigmasms/shared-types'

import { permissionPresets, proxy } from '@/utils'

import { presetOrDomain } from '@/components/services/url-shortener/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }), presetOrDomain ],

  props: {
    isNew: Boolean,
    loading: Boolean,
    paddless: Boolean
  },

  data() {
    return {
      currentTab: 'byPreset',
      generationParamsValidation: false,
      expireUrlValid: true
    }
  },

  computed: {
    isUrl() {
      const fullUrl = this.proxy.fullUrl?.trim()

      return regExp.validUrl.test(fullUrl ?? '')
    },

    canGetPresets() {
      return this.checkPermissions(`advanced.${getServiceNameViaPoint(Services['url-shortener-settings/domains'])}.get`, permissionPresets.meUp)
    },
    canGetDomains() {
      return this.checkPermissions(`advanced.${getServiceNameViaPoint(Services['url-shortener-settings/presets'])}.get`, permissionPresets.meUp)
    },

    $_currentTab: {
      get() {
        const byPreset = (Boolean(this.proxy.presetId) || Boolean(this.$_presetId)) && this.canGetPresets
        const byDomain = (Boolean(this.proxy.domainId) || Boolean(this.$_domainId)) && this.canGetDomains
        switch (true) {
          case byPreset: return 'byPreset'
          case byDomain: return 'byDomain'
          default: return this.currentTab
        }
      },
      set(value) {
        this.currentTab = value
      }
    },

    $_generationParams() {
      return this.value?.meta?.generationParams
    },
    $_fields() {
      if (!this.$_generationParams) {
        return []
      }

      return Object.keys(this.$_generationParams)
    },

    link() {
      const baseURL = '#/links'
      switch (this.$_currentTab) {
        case 'byPreset': return [ baseURL, 'presets' ].join('/')
        case 'byDomain': return [ baseURL, 'domains' ].join('/')
        default: return baseURL
      }
    },

    isExpireHidden() {
      return this.isNew && this.$_currentTab !== 'byDomain'
    },

    validation() {
      if (!this.isExpireHidden && !this.expireUrlValid) {
        return false
      }
      if (!this.isNew) {
        return this.isUrl
      }
      if (this.proxy.generationParams) {
        return this.generationParamsValidation
      }

      return this.isUrl && (Boolean(this.proxy.domainId) || Boolean(this.proxy.presetId))
    },

    shortUrl() {
      return getShortUrl(this.proxy)
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },

    currentTab(value) {
      switch (value) {
        case 'byPreset': {
          this.$set(this.proxy, 'presetId', this.proxy.presetId || undefined)
          this.$delete(this.proxy, 'domainId')
          this.$delete(this.proxy, 'generationParams')
          this.$delete(this.proxy, 'expireAfterHrs')
          this.$delete(this.proxy, 'expireUrl')
          this.$delete(this.proxy, 'deleteAfterExpireDays')
          break
        }
        case 'byDomain': {
          this.$set(this.proxy, 'domainId', this.proxy.domainId || undefined)
          this.$set(this.proxy, 'generationParams', cloneDeep(empty.urlShortenerSettingsPresets.create.generationParams))
          this.$delete(this.proxy, 'presetId')
          break
        }
      }
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  methods: {
    disabledItemCallback(item) {
      const state = get(item, 'domain.state')

      return state !== undefined && state !== EUrlShortenerSettingsDomainsStates.active
    }
  },

  render
}

